export const MULTI_MARKET_EXTRA_TAB_ID = 'extra-temporary-tab';
